import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import AboutSection from "./components/AboutSection";
import TrendingSection from "./components/TrendingSection";
import CTASection from "./components/CTASection";
import TestimonialsSection from "./components/TestimonialsSection";

export default function Home() {
  return (
    <main>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: "Pandabuy Sheet — Smart Product Comparison Spreadsheets",
            description: "Discover structured product data, price comparisons, and curated spreadsheets across 14+ shopping categories including shoes, hoodies, t-shirts, jackets, bags, and accessories.",
            url: (typeof import.meta !== "undefined" && import.meta.env?.VITE_SITE_URL) ? `${import.meta.env.VITE_SITE_URL}/` : "https://pandabuy.tattoo/",
          }),
        }}
      />
      <Navbar />
      <HeroSection />
      <CategoryGrid />
      <AboutSection />
      <TrendingSection />
      <TestimonialsSection />
      <CTASection />
      <Footer />
    </main>
  );
}